"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceInformation = void 0;
const ua_parser_js_1 = __importDefault(require("ua-parser-js"));
const getDeviceDetails = () => {
    // Condition picked from browser-detect package to handle react-native
    if (typeof document === 'undefined' &&
        typeof navigator !== 'undefined' &&
        navigator.product === 'ReactNative') {
        return {
            browser_name: 'react_native',
        };
    }
    if (typeof navigator === 'undefined' || !navigator.userAgent)
        return {};
    const parser = new ua_parser_js_1.default(navigator.userAgent).getResult();
    const { device: { model = '', vendor = '', type = '' } = {}, browser: { name: browserName = '', version: browserVersion = '' } = {}, os: { name: osName = '', version: osVersion = '' } = {}, } = parser || {};
    return {
        model,
        vendor,
        type,
        browser_name: browserName,
        browser_version: browserVersion,
        os_name: osName,
        os_version: osVersion,
        user_agent: navigator.userAgent,
    };
};
const getDeviceConnection = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    if (typeof navigator === 'undefined' || !navigator.connection)
        return {};
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const { downlink, effectiveType, rtt } = navigator.connection || {};
    return {
        downlink,
        effective_type: effectiveType,
        rtt,
    };
};
const getDeviceDimension = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined')
        return {};
    const { screen: { height: screenHeight, width: screenWidth } = {}, innerHeight: viewportHeight, innerWidth: viewportWidth, } = window;
    return {
        screen_height: screenHeight,
        screen_width: screenWidth,
        viewport_height: viewportHeight,
        viewport_width: viewportWidth,
    };
};
const getDeviceInformation = () => {
    try {
        return {
            device_details: {
                ...getDeviceDetails(),
            },
            device_connection: {
                ...getDeviceConnection(),
            },
            device_dimension: {
                ...getDeviceDimension(),
            },
        };
    }
    catch (e) {
        return {
            device_details: {},
            device_connection: {},
            device_dimension: {},
        };
    }
};
exports.getDeviceInformation = getDeviceInformation;
//# sourceMappingURL=deviceDetails.js.map